import React from "react";
import { TCustomer } from "../../../../types/Types";
import Button from "../../../../components/buttons/Button";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";

interface ProfileHeaderProps {
  customer: TCustomer;
  onEdit: () => void;
}

const ProfileHeader = ({ customer, onEdit }: ProfileHeaderProps) => {
  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden">
      <div className="h-32 bg-gradient-to-r from-primary/80 to-primary" />
      <div className="px-8 pb-8">
        <div className="relative flex flex-col md:flex-row items-end -mt-12 gap-6">
          <div className="w-32 h-32 bg-white rounded-3xl p-1.5 shadow-xl">
            <div className="w-full h-full bg-gray-50 rounded-2xl flex items-center justify-center text-primary text-4xl font-black border border-gray-100">
              {customer.fullName.charAt(0)}
            </div>
          </div>
          <div className="flex-1 pb-2">
            <div className="flex items-center gap-3">
              <h1 className="text-3xl font-black text-gray-900">
                {customer.fullName}
              </h1>
              {customer.disabled ? (
                <span className="px-3 py-1 bg-red-50 text-red-600 text-xs font-bold rounded-full border border-red-100 flex items-center gap-1">
                  <ExclamationCircleIcon className="w-3.5 h-3.5" />
                  Disabled
                </span>
              ) : (
                <span className="px-3 py-1 bg-green-50 text-green-600 text-xs font-bold rounded-full border border-green-100 flex items-center gap-1">
                  <CheckCircleIcon className="w-3.5 h-3.5" />
                  Active
                </span>
              )}
            </div>
            <p className="text-gray-500 font-medium flex items-center gap-2 mt-1">
              <span className="text-xs text-gray-300">ID:</span> {customer._id}
            </p>
          </div>
          <div className="flex gap-3 pb-2">
            <Button
              title="Edit Profile"
              onClick={onEdit}
              className="!px-4 !py-2 flex items-center gap-2"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
